import { render, staticRenderFns } from "./characterManage.vue?vue&type=template&id=390fdf8e&scoped=true&"
import script from "./characterManage.vue?vue&type=script&lang=js&"
export * from "./characterManage.vue?vue&type=script&lang=js&"
import style0 from "./characterManage.vue?vue&type=style&index=0&id=390fdf8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390fdf8e",
  null
  
)

export default component.exports